import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent, TermsAndConditionsComponent } from '../../components';

const loginRoutes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'login/settings/termsandconditions',
    component: TermsAndConditionsComponent
  }
];

export const loginRouting: ModuleWithProviders<any> = RouterModule.forChild(loginRoutes);
